// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/.pnpm/css-loader@7.1.5_webpack@5.111.1/node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/.pnpm/css-loader@7.1.5_webpack@5.111.1/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.CustomButton-module__Container__lpNGA {
    padding-right: var(--ds-sm);
    padding-left: var(--ds-sm);
    background-color: var(--ds-color-indigo-2);
}

.CustomButton-module__Container__lpNGA:hover {
    background-color: var(--ds-color-indigo-3);
}

.CustomButton-module__ChangeIndicator__lva8l {
    position: absolute;
    top: calc(var(--ds-xs) * -1);
    right: calc(var(--ds-05x) * -1);
    width: var(--ds-m);
    height: var(--ds-m);
    background-color: var(--ds-color-neon);
    border-color: var(--ds-color-grey-indigo-90);
    border-style: solid;
    border-width: var(--ds-05x);
    border-radius: var(--ds-sm);
}
`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"Container": `CustomButton-module__Container__lpNGA`,
	"ChangeIndicator": `CustomButton-module__ChangeIndicator__lva8l`
};
export default ___CSS_LOADER_EXPORT___;
